import { Controller } from '@hotwired/stimulus'
import { showElement, hideElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ["toggleable"]

  // If the target String is matched, it will toggleShow for all elements with that value
  // If the target String does not match, it will toggleHide for all elements without that value
  static values = {
    target: String
  }

  toggle(event) {
    this.toggleableTargets.forEach((element) => {
      hideElement(element)
    })

    this.getFilteredTarget(event.target.value).forEach((element) => {
      showElement(element)
    })
  }

  getFilteredTarget(value) {
    return Array.from(this.toggleableTargets).filter((target) => {
      return target.getAttribute("data-element-visibility-multi-toggle-target-value") === value
    })
  }
}
